import { Editor, Transforms } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function unwrapNodes(editor: Editor, options?: WithQueryOptions<typeof Transforms.unwrapNodes, 1>) {
    Transforms.unwrapNodes(editor, getQueryOptions(editor, options));
}
